import _ from 'lodash'
import PropTypes from 'prop-types'

export default function FormattedPhone ({ number }) {
  if (_.isNil(number)) {
    return null
  }
  const trimmed = value => value.replace(/\D/g, '')
  const first10 = value => value.substr(0, 10)
  const formatted = value =>
    value.replace(/^(\d{3})(\d{3})(\d{4}).*/, '$1.$2.$3')
  return <div>{formatted(first10(trimmed(number)))}</div>
}
FormattedPhone.propTypes = {
  number: PropTypes.string
}
